import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "ELECTRIC",
  title: defineMessage({
    id: "fig.quality.ELECTRIC.title",
    defaultMessage: `Availability of electricity and internet for pedagogical purposes in schools in selected countries`,
  }),
  caption: defineMessage({
    id: "fig.quality.ELECTRIC.caption",
    defaultMessage: `The availability of internet at school often lags far behind electrification.`,
  }),
  source: defineMessage({
    id: "fig.quality.ELECTRIC.source",
    defaultMessage: `UIS database`,
  }),
};
